import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import LabelledInput from 'components/LabelledInput';
import LabelledSelect from 'components/LabelledSelect';
import { getCountries, getCanadaProvinces, getUsStates } from 'libs/geographicalRegion';
import {
  ADDRESS_INFO_KEYS, getRegionPlaceholderText, getZipCodePlaceholderText
} from './config';
import styles from './style';
import './AddressForm.scss';

const countries = getCountries();
const canadaProvinces = getCanadaProvinces();
const usStates = getUsStates();

function getRegion(country) {
  if (country && country.value === 'US') {
    return usStates;
  } else if (country && country.value === 'CA') {
    return canadaProvinces;
  }
  return [];
}

function selectedCountry(country) {
  let isSelected = false;
  if (country && (country.value === 'US' || country.value === 'CA')) {
    isSelected = true;
  }
  return isSelected;
}

class AddressForm extends React.PureComponent {
  render() {
    const {
      addressInfo,
      errorInfoAddressForm,
      handleInputChange,
      handleChangePhoneNumber,
      handleChangeZipCode,
      handleAddressFormSave,
      intl
    } = this.props;
    const country = addressInfo[ADDRESS_INFO_KEYS.COUNTRY];
    const isUSAndCACountrySelected = selectedCountry(country);
    const regionErrorText = isUSAndCACountrySelected ? errorInfoAddressForm[ADDRESS_INFO_KEYS.REGION] : '';
    const zipCodeErrorText = isUSAndCACountrySelected ? errorInfoAddressForm[ADDRESS_INFO_KEYS.ZIP_CODE] : '';
    const zipCodeValue = isUSAndCACountrySelected ? addressInfo[ADDRESS_INFO_KEYS.ZIP_CODE] : '';
    return (
      <div className="SubscriptionActivate__AddressForm">
        <div className="SubscriptionActivate__AddressForm__ContentWrap">
          <div className="SubscriptionActivate__AddressForm__ContentWrap__Content">
            <div className="SubscriptionActivate__AddressForm__ContentWrap__Content__NameSection">
              <div className="SubscriptionActivate__AddressForm__ContentWrap__Content__InputWrap">
                <LabelledInput
                  name={ADDRESS_INFO_KEYS.FIRST_NAME}
                  onChange={handleInputChange}
                  placeholder={intl.formatMessage({ id: 'views.subscriptionActivate.addressDetails.addressFrom.contentWrap.content.inputWrap.firstName.placeholder' })}
                  value={addressInfo[ADDRESS_INFO_KEYS.FIRST_NAME]}
                  onEnter={handleAddressFormSave}
                  errorText={errorInfoAddressForm[ADDRESS_INFO_KEYS.FIRST_NAME] &&
                    intl.formatMessage({ id: errorInfoAddressForm[ADDRESS_INFO_KEYS.FIRST_NAME] })}
                />
              </div>
              <div className="SubscriptionActivate__AddressForm__ContentWrap__Content__InputWrap">
                <LabelledInput
                  name={ADDRESS_INFO_KEYS.LAST_NAME}
                  onChange={handleInputChange}
                  placeholder={intl.formatMessage({ id: 'views.subscriptionActivate.addressDetails.addressFrom.contentWrap.content.inputWrap.lastName.placeholder' })}
                  value={addressInfo[ADDRESS_INFO_KEYS.LAST_NAME]}
                  onEnter={handleAddressFormSave}
                  errorText={errorInfoAddressForm[ADDRESS_INFO_KEYS.LAST_NAME] &&
                    intl.formatMessage({ id: errorInfoAddressForm[ADDRESS_INFO_KEYS.LAST_NAME] })}
                />
              </div>
            </div>
            <div className="SubscriptionActivate__AddressForm__ContentWrap__Content__InputWrap">
              <LabelledInput
                name={ADDRESS_INFO_KEYS.ADDRESS}
                onChange={handleInputChange}
                placeholder={intl.formatMessage({ id: 'views.subscriptionActivate.addressDetails.addressFrom.contentWrap.content.inputWrap.address.placeholder' })}
                value={addressInfo[ADDRESS_INFO_KEYS.ADDRESS]}
                onEnter={handleAddressFormSave}
                errorText={errorInfoAddressForm[ADDRESS_INFO_KEYS.ADDRESS] &&
                  intl.formatMessage({ id: errorInfoAddressForm[ADDRESS_INFO_KEYS.ADDRESS] })}
              />
            </div>
            <div className="SubscriptionActivate__AddressForm__ContentWrap__Content__InputWrap">
              <LabelledInput
                name={ADDRESS_INFO_KEYS.APARTMENT}
                onChange={handleInputChange}
                placeholder={intl.formatMessage({ id: 'views.subscriptionActivate.addressDetails.addressFrom.contentWrap.content.inputWrap.apartment.placeholder' })}
                value={addressInfo[ADDRESS_INFO_KEYS.APARTMENT]}
                onEnter={handleAddressFormSave}
                errorText={errorInfoAddressForm[ADDRESS_INFO_KEYS.APARTMENT] &&
                  intl.formatMessage({ id: errorInfoAddressForm[ADDRESS_INFO_KEYS.APARTMENT] })}
              />
            </div>
            <div className="SubscriptionActivate__AddressForm__ContentWrap__Content__InputWrap">
              <LabelledInput
                name={ADDRESS_INFO_KEYS.CITY}
                onChange={handleInputChange}
                placeholder={intl.formatMessage({ id: 'views.subscriptionActivate.addressDetails.addressFrom.contentWrap.content.inputWrap.city.placeholder' })}
                value={addressInfo[ADDRESS_INFO_KEYS.CITY]}
                onEnter={handleAddressFormSave}
                errorText={errorInfoAddressForm[ADDRESS_INFO_KEYS.CITY] &&
                  intl.formatMessage({ id: errorInfoAddressForm[ADDRESS_INFO_KEYS.CITY] })}
              />
            </div>
            <div className="SubscriptionActivate__AddressForm__ContentWrap__Content__SelectSection">
              <div className="SubscriptionActivate__AddressForm__ContentWrap__Content__InputWrap">
                <LabelledSelect
                  className="SubscriptionActivate__AddressForm__ContentWrap__Content__Input--Select"
                  isError={!!errorInfoAddressForm[ADDRESS_INFO_KEYS.COUNTRY]}
                  type="select"
                  labelText={intl.formatMessage({ id: 'views.subscriptionActivate.addressDetails.addressFrom.contentWrap.content.inputWrap.country.label' })}
                  placeholder={intl.formatMessage({ id: 'views.subscriptionActivate.addressDetails.addressFrom.contentWrap.content.inputWrap.country.placeholder' })}
                  name={ADDRESS_INFO_KEYS.COUNTRY}
                  value={addressInfo[ADDRESS_INFO_KEYS.COUNTRY]}
                  onChange={handleInputChange}
                  errorText={errorInfoAddressForm[ADDRESS_INFO_KEYS.COUNTRY] &&
                    intl.formatMessage({ id: errorInfoAddressForm[ADDRESS_INFO_KEYS.COUNTRY] })}
                  options={countries}
                  chevronIconUp="chevron-up-filled"
                  chevronIconDown="chevron-down-filled"
                  chevronIconColor={styles.chevronIconColor}
                  chevronIconStyle={styles.chevronIconStyle}
                />
              </div>
              <div
                className="SubscriptionActivate__AddressForm__ContentWrap__Content__InputWrap"
              >
                <LabelledSelect
                  isError={isUSAndCACountrySelected &&
                    !!errorInfoAddressForm[ADDRESS_INFO_KEYS.REGION]}
                  type="select"
                  labelText={intl.formatMessage({ id: 'views.subscriptionActivate.addressDetails.addressFrom.contentWrap.content.inputWrap.region.label' })}
                  placeholder={intl.formatMessage({ id: getRegionPlaceholderText(country) })}
                  cssStylesRoot={styles.inputStyle}
                  name={ADDRESS_INFO_KEYS.REGION}
                  value={addressInfo[ADDRESS_INFO_KEYS.REGION]}
                  onChange={handleInputChange}
                  errorText={regionErrorText && intl.formatMessage({ id: regionErrorText })}
                  options={getRegion(country)}
                  isDisabled={!isUSAndCACountrySelected}
                  chevronIconUp="chevron-up-filled"
                  chevronIconDown="chevron-down-filled"
                  chevronIconColor={styles.chevronIconColor}
                  chevronIconStyle={styles.chevronIconStyle}
                />
              </div>
              <div className={`SubscriptionActivate__AddressForm__ContentWrap__Content__InputWrap ${!isUSAndCACountrySelected && 'Disable__Input'}`}>
                <LabelledInput
                  name={ADDRESS_INFO_KEYS.ZIP_CODE}
                  onChange={handleChangeZipCode}
                  placeholder={intl.formatMessage({ id: getZipCodePlaceholderText(country) })}
                  disabled={!isUSAndCACountrySelected}
                  value={zipCodeValue}
                  onEnter={handleAddressFormSave}
                  errorText={zipCodeErrorText && intl.formatMessage({ id: zipCodeErrorText })}
                />
              </div>
            </div>
            <div className="SubscriptionActivate__AddressForm__ContentWrap__Content__InputWrap">
              <LabelledInput
                name={ADDRESS_INFO_KEYS.PHONE_NUMBER}
                onChange={handleChangePhoneNumber}
                placeholder={intl.formatMessage({ id: 'views.subscriptionActivate.addressDetails.addressFrom.contentWrap.content.inputWrap.phoneNumber.placeholder' })}
                value={addressInfo[ADDRESS_INFO_KEYS.PHONE_NUMBER]}
                onEnter={handleAddressFormSave}
                errorText={errorInfoAddressForm[ADDRESS_INFO_KEYS.PHONE_NUMBER] &&
                  intl.formatMessage({ id: errorInfoAddressForm[ADDRESS_INFO_KEYS.PHONE_NUMBER] })}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AddressForm.propTypes = {
  addressInfo: PropTypes.object.isRequired,
  errorInfoAddressForm: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleChangePhoneNumber: PropTypes.func.isRequired,
  handleChangeZipCode: PropTypes.func.isRequired,
  handleAddressFormSave: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired
};

export default injectIntl(AddressForm);



// WEBPACK FOOTER //
// ./src/views/SubscriptionActivate/AddressDetails/AddressForm.jsx